import { HubFeature } from '@ats/api/cm';
import { LocDef, LocDefs, LocMap, MapLocKeys } from '@cm/core/localization';

const displayPathStart = 'Catalogs|Benefits|Edit History|';
const sharedLocProperties: Pick<LocDef, 'htmlAllowed' | 'shared' | 'portal' | 'feature'> = {
	htmlAllowed: false,
	shared: false,
	portal: 'SP',
	feature: HubFeature.Benefit,
};

export type BenefitEditHistoryLocs = 'SPBenefitEditHistoryTitle' | 'SPBenefitEditHistoryNoHistory';

export const spBenefitEditHistoryLocs: LocDefs<BenefitEditHistoryLocs> = {
	SPBenefitEditHistoryTitle: {
		defaultValue: 'Edit History',
		displayType: 'Title',
		description: 'Ttile for the benefit edit history page.',
		displayPath: `${displayPathStart}Title`,
		legacyName: 'Benefit/Catalogs.Benefits.EditHistory.Title.SectionTitle',
		...sharedLocProperties,
	},
	SPBenefitEditHistoryNoHistory: {
		defaultValue: 'No history available',
		displayType: 'Content',
		description: 'Content shown when there is no edit history available.',
		displayPath: `${displayPathStart}No History`,
		legacyName: 'Benefit/Catalogs.Benefits.EditHistory.Content.NoHistory',
		...sharedLocProperties,
	},
};

export const LOC_KEYS = MapLocKeys<BenefitEditHistoryLocs>(spBenefitEditHistoryLocs);
export type SPBenefitEditHistoryLocsType = LocMap<BenefitEditHistoryLocs>;
